// this is an autogenerated file from App/ChooseLocation/Support/Audit/Content/Users/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_ChooseLocation_Support_Audit_Content_Users($xid: String!) {
  app_admin_users_access(
    where: {
      xid: { _eq: $xid }
      organization_level: { _eq: "parent" }
      is_support: { _eq: false }
    }
  ) {
    id
    user {
      id
      email
      vaxiom_person {
        id
        first_name
        last_name
      }
    }
  }
}

`